import {
    Box,
    Tab,
    Tabs,
    alpha
} from "@mui/material";
import {
    Dispatch,
    SetStateAction
} from "react";

import { PropertyTab } from "../../lib/property/v2/PropertyTab";
import { grey } from "@mui/material/colors";
import theme from "../../assets/style/theme";

type PropertyInfoProps = {
    activeTab: PropertyTab;
    setActiveTab: Dispatch<SetStateAction<PropertyTab>>;
};

const PropertyTabs = (props: PropertyInfoProps) => {
    const { activeTab, setActiveTab } = props;

    return (
        <Box
            justifyContent="center"
            alignItems="center"
            sx={{
                backgroundColor: "white",
                "& .MuiTab-root": {
                    border: `${grey[300]} 1px solid`, // Invisible border to prevent tab from jumping when selected
                    backgroundColor: grey[300],
                },
                "& .Mui-selected": {
                    border: `${theme.palette.primary.light} 1px solid`,
                    backgroundColor: alpha(theme.palette.primary.light, 0.2),
                    color: theme.palette.primary.main
                },
            }}
        >
            <Tabs
                value={activeTab}
                onChange={(event, newValue) => setActiveTab(newValue)}
                variant="fullWidth"
                TabIndicatorProps={{
                    sx: {
                        display: "none"
                    }
                }}
            >
                <Tab
                    value={PropertyTab.DETAILS}
                    label={"Property"}
                    sx={{ fontSize: theme.typography.h6.fontSize }}
                />
                <Tab
                    value={PropertyTab.ISSUES}
                    label="Issues"
                    sx={{ fontSize: theme.typography.h6.fontSize }}
                />
                <Tab
                    value={PropertyTab.SOLUTIONS}
                    label="Solutions"
                    sx={{ fontSize: theme.typography.h6.fontSize }}
                />
            </Tabs>
        </Box>
    );
};

export default PropertyTabs;
